import { useEffect, useState } from 'react'

type SafeImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string
  altSrc: string
}

export default function SafeImage({ src, altSrc, alt, ...props }: SafeImageProps) {
  const [finalSrc, setFinalSrc] = useState<string>(src)
  useEffect(() => {
    let cancelled = false
    const img = new Image()
    img.src = src

    img.onload = () => {
      if (!cancelled) setFinalSrc(src)
    }
    img.onerror = () => {
      if (!cancelled) setFinalSrc(altSrc)
    }

    return () => {
      cancelled = true
    }
  }, [src, altSrc])

  if (!finalSrc) {
    return null
  }

  return (
    <img
      src={finalSrc}
      alt={alt}
      {...props}
    />
  )
}
